export default __webpack_public_path__ + "static/media/06__o_preview_5.bae49cc7.jpg";